module.exports = __webpack_public_path__ + "static/media/icon_1.cbaa8152.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_imagerecognition/icon_1.svg
// module id = 539
// module chunks = 0